import React from "react";

import "./terms_and_condition.scss";
const Termsandcondition = () => {
  return (
    <>
      <div className="terms_condition">
        <div className="container">
          <h3>01. What Are Terms and Conditions?</h3>
          <p>
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry. Lorem Ipsum has been the industry's standard dummy text
            ever since the 1500s, when an unknown printer took a galley of type
            and scrambled it to make a type specimen book. It has survived not
            only five centuries but also the on leap into electronic
            typesetting, remaining essentially unchanged. It wasn’t popularised
            in the 1960s with the release of Letraset sheets containing Lorem
            Ipsum passages, andei more recently with desktop publishing software
            like Aldus PageMaker including versions of Lorem Ipsum to make a
            type specimen book.
          </p>
          <h3>02. What Are Terms and Conditions?</h3>
          <p>
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry. Lorem Ipsum has been the industry's standard dummy text
            ever since the 1500s, when an unknown printer took a galley of type
            and scrambled it to make a type specimen book. It has survived not
            only five centuries but also the on leap into electronic
            typesetting, remaining essentially unchanged. It wasn’t popularised
            in the 1960s with the release of Letraset sheets containing Lorem
            Ipsum passages, andei more recently with desktop publishing software
            like Aldus PageMaker including versions of Lorem Ipsum to make a
            type specimen book.
          </p>

          <h3>03. Does My Online Shop Need Terms and Conditions?</h3>
          <p>
            While it’s not legally required for ecommerce websites to have a
            terms and conditions agreement, adding one will help protect your
            online business.As terms and conditions are legally enforceable
            rules, they allow you to set standards for how users interact with
            your site. Here are some of the major benefits of including terms
            and conditions on your ecommerce site:
            <br></br>
            <br></br>
            has survived not only five centuries but also the on leap into
            electronic typesetting, remaining essentially unchanged. It wasn’t
            popularised in the 1960s with the release of Letraset sheets
            containing Lorem Ipsum passages, andei more recently with desktop.
          </p>

          <h3>04. Does My Online Shop Need Terms and Conditions?</h3>
          <ul>
            <li>1- &nbsp; slim body with metal cover</li>
            <li>
              2 -&nbsp; latest Intel Core i5-1135G7 processor (4 cores / 8
              threads)
            </li>
            <li>3 - &nbsp; 8GB DDR4 RAM and fast 512GB PCIe SSD</li>
          </ul>

          <h3>05. Protect Your Property</h3>
          <p>
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry. Lorem Ipsum has been the industry's standard dummy text
            ever since the 1500s, when an unknown printer took a galley of type
            and scrambled it to make a type specimen book. It has survived not
            only five centuries but also the on leap into electronic
            typesetting, remaining essentially unchanged. It wasn’t popularised
            in the 1960s with the release of Letraset sheets containing Lorem
            Ipsum passages, andei more recently with desktop publishing software
            like Aldus PageMaker including versions of Lorem Ipsum to make a
            type specimen book. five centuries but also the on leap into
            electronic typesetting, remaining essentially unchanged. It wasn’t
            popularised in the 1960s with the release of Letraset sheets
            containing Lorem Ipsum passages, andei more recently with desktop
            publishing software like Aldus PageMaker including versions of Lorem
            Ipsum to make a type specimen book.
          </p>

          <h3>06.Pricing and Payment Terms</h3>
          <p>
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry. Lorem Ipsum has been the industry's standard dummy text
            ever since the 1500s, when an unknown printer took a galley of type
            and scrambled it to make a type specimen book. It has survived not
            only five centuries but also the on leap into electronic
            typesetting, remaining essentially unchanged. It wasn’t popularised
            in the 1960s with the release of Letraset sheets containing Lorem
            Ipsum passages, andei more recently with desktop publishing software
            like Aldus PageMaker including versions of Lorem Ipsum to make a
            type specimen book. five centuries but also the on leap into
            electronic typesetting, remaining essentially unchanged. It wasn’t
            popularised in the 1960s with the release of Letraset sheets
            containing Lorem Ipsum passages, andei more recently with desktop
            publishing software like Aldus PageMaker including versions of Lorem
            Ipsum to make a type specimen book.
          </p>
        </div>
        <div className="discount">
          <h3>
            Get <span>20%</span>Off Discount Coupon
          </h3>
          <p>by Subscribe our Newsletter</p>
          <form>
            <input
              type="email"
              required
              aria-required="true"
              placeholder="Enter your email"
            ></input>
            <button className="Submit">Get The Copon</button>
          </form>
        </div>
      </div>
    </>
  );
};

export default Termsandcondition;
